<template>
	<div>
		<h3 class="mb-0">MHLV Product Details</h3>
		<b-form role="form" class="mt-4" @submit.prevent="addMhlv">
			<b-row>
				<b-col cols="12">
					<b-form-group label="Loan Type">
						<el-select v-model="form.prod_mhlv_loan_type" placeholder="Select" allow-create filterable>
							<el-option v-for="(item, index) in LOAN_TYPE_OPTIONS" :key="index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</b-form-group>
				</b-col>

				<b-col cols="12">
					<b-form-group label="Loan Amount (RM)">
						<CurrencyInput v-model="form.prod_mhlv_loan_amount"
							:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
					</b-form-group>
				</b-col>

				<b-col cols="12">
					<b-form-group label="Interest Rate (%)">
						<b-form-input v-model="form.prod_mhlv_interest_rate" type="number" step="0.01"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12">
					<b-form-group label="Tenure (Year)">
						<b-form-input v-model="form.prod_mhlv_tenure" type="number" step="1"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12">
					<b-form-group label="Installment">
						<b-form-input v-model="form.prod_mhlv_installment" type="number" step="0.01"></b-form-input>
					</b-form-group>
				</b-col>


				<b-col cols="12">
					<h3 class="mb-4">Arrangement Fee</h3>
				</b-col>

				<b-col cols="12">
					<b-form-group label="Arrangement Fee Amount">
						<b-form-input v-model="form.prod_mhlv_agreement_amt" type="number" step="0.01"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12">
					<b-form-group label="Arrangement Fee SST">
						<b-form-radio-group v-model="form.prod_mhlv_agreement_rate_sst" :options="SST_OPTIONS"></b-form-radio-group>
					</b-form-group>
				</b-col>

				<b-col ols="12">
					<b-form-group label="Total Arrangement Fee (RM)">
						<b-form-input v-model="form.prod_mhlv_agreement_fees" type="text" required disabled
							placeholder="0.00"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12">
					<b-button block variant="primary" class="mb-5" type="submit">Add</b-button>
				</b-col>
			</b-row>
		</b-form>
	</div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import CurrencyInput from '@/components/CurrencyInput'
import {
	notifyFunctionMixin,
	helperFunctionMixin
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { PRODUCT_MHLV, SST_OPTIONS } from '@/assets/js/options.js'

export default {
	mixins: [
		notifyFunctionMixin,
		helperFunctionMixin
	],
	components: {
		CurrencyInput,
		[Select.name]: Select,
		[Option.name]: Option,
		[RadioGroup.name]: RadioGroup,
		[RadioButton.name]: RadioButton,
	},
	data() {
		return {
			form: {
				prod_mhlv_loan_type: '',
				prod_mhlv_loan_amount: 0,
				prod_mhlv_interest_rate: 0,
				prod_mhlv_tenure: 0,
				prod_mhlv_installment: 0,
				prod_mhlv_agreement_amt: 0,
				prod_mhlv_agreement_rate_sst: 0,
				prod_mhlv_agreement_fees: 0
			},
			LOAN_TYPE_OPTIONS: PRODUCT_MHLV.LOAN_TYPE,
			SST_OPTIONS: SST_OPTIONS,
		}
	},
	watch: {
		'form': {
			handler(newVal) {
				if (newVal) {
					let sst_fee = parseFloat(this.form.prod_mhlv_agreement_amt) * parseFloat(this.form.prod_mhlv_agreement_rate_sst) / 100
					//set total arragement fee
					let arrangement_fee_amount = parseFloat(this.form.prod_mhlv_agreement_amt) + parseFloat(sst_fee)
					if (isNaN(arrangement_fee_amount)) {
						this.form.prod_mhlv_agreement_fees = 0
					} else {
						this.form.prod_mhlv_agreement_fees = arrangement_fee_amount
					}
				}
			},
			deep: true
		}
	},
	methods: {
		...mapActions(useProductStore, ['createMhlvProduct']),
		resetForm() {
			this.form = {
				prod_mhlv_loan_type: '',
				prod_mhlv_loan_amount: 0,
				prod_mhlv_interest_rate: 0,
				prod_mhlv_tenure: 0,
				prod_mhlv_installment: 0,
				prod_mhlv_agreement_amt: 0,
				prod_mhlv_agreement_rate_sst: 0,
				prod_mhlv_agreement_fees: 0
			}
		},
		async addMhlv() {
			if (this.form.prod_mhlv_loan_type == '') {
				this.errorFunction(null, 'Please Chosse Loan Type.')
				return
			}

			const mhlv = {
				prod_mhlv_loan_type: this.form.prod_mhlv_loan_type,
				prod_mhlv_loan_amount: this.form.prod_mhlv_loan_amount,
				prod_mhlv_interest_rate: this.form.prod_mhlv_interest_rate,
				prod_mhlv_tenure: this.form.prod_mhlv_tenure,
				prod_mhlv_installment: this.form.prod_mhlv_installment,
				prod_mhlv_agreement_amt: this.form.prod_mhlv_agreement_amt,
				prod_mhlv_agreement_rate_sst: this.form.prod_mhlv_agreement_rate_sst,
				prod_mhlv_agreement_fees: this.form.prod_mhlv_agreement_fees,
			}

			useProductStore().$patch((state) => {
				state.current_product_data = {
					...state.current_product_data,
					mhlv: mhlv
				}
			})

			try {
				await this.createMhlvProduct()
				this.notifySuccess('<b>Draft </b> - Successfully Created.')
				this.resetForm()
				solutionEventBus.$emit('show-mhlv-summary')
			} catch (e) {
				this.errorFunction(null, e)
			}
		},
		emitEvent(eventName) {
			solutionEventBus.$emit(eventName)
		},
	}
}
</script>